module.exports = __webpack_public_path__ + "img/1958_.2d58c6a7.svg";